import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import {
    Box,
    Container,
    Paper,
    Typography,
    Button,
    Stack,
    TextField,
} from "@mui/material";
import AdminPanelSettingsOutlinedIcon from "@mui/icons-material/AdminPanelSettingsOutlined";

import bannerFundo from "../assets/cabine.jpg";
import { login } from "../services/authService";

export default function Login() {
    const navigate = useNavigate();

    const [email, setEmail] = useState("");
    const [senha, setSenha] = useState("");
    const [loading, setLoading] = useState(false);

    async function handleLogin(e) {
        e.preventDefault();
        setLoading(true);

        try {
            await login(email, senha);
            navigate("/admin");
        } catch (err) {
            alert(err.message || "Usuário ou senha inválidos");
        } finally {
            setLoading(false);
        }
    }

    const inputStyles = {
        input: { color: "#fff" },
        "& .MuiOutlinedInput-root": {
            background: "rgba(255,255,255,0.08)",
            borderRadius: 1,
            "& fieldset": {
                borderColor: "rgba(255,255,255,0.3)",
            },
            "&:hover fieldset": {
                borderColor: "#fff",
            },
            "&.Mui-focused fieldset": {
                borderColor: "var(--cise-blue)",
            },
        },
        "& .MuiInputLabel-root": {
            color: "var(--branco)",
        },
        "& .MuiInputLabel-root.Mui-focused": {
            color: "#fff",
        },
        "& .MuiInputLabel-root.MuiInputLabel-shrink": {
            color: "#fff",
        },
    };

    return (
        <Box
            sx={{
                minHeight: "100vh",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                backgroundImage: `url(${bannerFundo})`,
                backgroundSize: "cover",
                backgroundPosition: "center",
                position: "relative",
                px: 2,
            }}
        >
            {/* Overlay */}
            <Box
                sx={{
                    position: "absolute",
                    inset: 0,
                    background:
                        "linear-gradient(180deg, rgba(0,0,0,0.55), rgba(0,0,0,0.65))",
                    backdropFilter: "blur(2px)",
                }}
            />

            <Container maxWidth="xs" sx={{ zIndex: 1 }}>
                <Paper
                    elevation={0}
                    sx={{
                        p: 4,
                        borderRadius: 1,
                        background: "rgba(255,255,255,0.12)",
                        backdropFilter: "blur(18px)",
                        border: "1px solid rgba(255,255,255,0.25)",
                    }}
                >
                    <Stack
                        spacing={2.5}
                        alignItems="center"
                        component="form"
                        onSubmit={handleLogin}
                    >
                        <Typography variant="h4" sx={{ fontWeight: 900, color: "#fff" }}>
                            CISE
                        </Typography>

                        <Typography
                            sx={{
                                color: "rgba(255,255,255,0.75)",
                                fontSize: 14,
                                textAlign: "center",
                            }}
                        >
                            Cultura Inglesa de Sergipe
                            <br />
                            Acesso Administrativo
                        </Typography>

                        <TextField
                            fullWidth
                            label="E-mail"
                            value={email}
                            onChange={(e) => setEmail(e.target.value)}
                            sx={inputStyles}
                        />

                        <TextField
                            fullWidth
                            label="Senha"
                            type="password"
                            value={senha}
                            onChange={(e) => setSenha(e.target.value)}
                            sx={inputStyles}
                        />

                        <Button
                            fullWidth
                            size="large"
                            variant="contained"
                            type="submit"
                            disabled={loading}
                            startIcon={<AdminPanelSettingsOutlinedIcon />}
                            sx={{
                                mt: 1,
                                py: 1.4,
                                borderRadius: 1,
                                fontWeight: 800,
                                backgroundColor: "var(--cise-blue)",
                                "&:hover": {
                                    backgroundColor: "var(--cise-red)",
                                },
                            }}
                        >
                            {loading ? "Entrando..." : "Entrar no Painel"}
                        </Button>

                        <Typography sx={{ fontSize: 12, color: "rgba(255,255,255,0.6)" }}>
                            Acesso restrito • Uso interno
                        </Typography>
                    </Stack>
                </Paper>
            </Container>
        </Box>
    );
}